webpackJsonp([39236203315009],{

/***/ 823:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/10.b809c945.png";

/***/ }),

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/2.7b45c21f.png";

/***/ }),

/***/ 825:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/3.a5619ae7.png";

/***/ }),

/***/ 826:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/4.72feb3e4.png";

/***/ }),

/***/ 827:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/5.e4fb6b58.png";

/***/ }),

/***/ 828:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/6.220f05e1.png";

/***/ }),

/***/ 829:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/7.3928817b.png";

/***/ }),

/***/ 830:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/8.e4fb6b58.png";

/***/ }),

/***/ 831:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/9.9efd446d.png";

/***/ }),

/***/ 1206:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(823);
	
	var _2 = _interopRequireDefault(_);
	
	var _3 = __webpack_require__(831);
	
	var _4 = _interopRequireDefault(_3);
	
	var _5 = __webpack_require__(830);
	
	var _6 = _interopRequireDefault(_5);
	
	var _7 = __webpack_require__(829);
	
	var _8 = _interopRequireDefault(_7);
	
	var _9 = __webpack_require__(828);
	
	var _10 = _interopRequireDefault(_9);
	
	var _11 = __webpack_require__(827);
	
	var _12 = _interopRequireDefault(_11);
	
	var _13 = __webpack_require__(826);
	
	var _14 = _interopRequireDefault(_13);
	
	var _15 = __webpack_require__(825);
	
	var _16 = _interopRequireDefault(_15);
	
	var _17 = __webpack_require__(824);
	
	var _18 = _interopRequireDefault(_17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Master = function Master(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "c-content-box" },
	    _react2.default.createElement(
	      "h2",
	      null,
	      "Supervised Master theses"
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { textAlign: 'justify', lineHeight: '2em' } },
	      "In the last years, I had the opportunity to mentor students graduating for a master degree and I\u2019m still doing it. Often, I\u2019m a co-supervisor, collaborating with a professor in the supervisory team. Below I show some abstract of the supervised theses, as written directly by the students. ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "h3",
	        null,
	        "Gianluca Clemente, 2017/2018"
	      ),
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Main supervisor: Prof. Domenico Raffaele"
	      ),
	      _react2.default.createElement("img", { src: _2.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Implementation of Displacement-Based Design for seismically-isolated girder bridges"
	      ),
	      "The following thesis has as its preliminary objective the study and implementation in Matlab of the new and more recent anti-seismic design procedure, based on Displacement-Based Design, for girder bridges subjected to seismic isolation. There are four procedures that simply take the name of Procedure A, Procedure B, Procedure C, Procedure D. After careful study, the four corresponding calculation codes were costructed which, in te next stage, were appropriately tested and validated in reference to a specific case study. The are a practical and useful tool to be used in future applications, designed to investigate various aspects of anti-seismic design of isolated girder bridges. ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "h3",
	        null,
	        "Donato Zambetta, 2017/2018"
	      ),
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Main supervisor: Prof. Domenico Raffaele"
	      ),
	      _react2.default.createElement("img", { src: _4.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Influence of the design parameters on the displacement-based design of multi-span continuous bridges"
	      ),
	      "In this work a displacement-based design procedure for multi-span reinforced concrete bridge structures when subjected to seismic action in the transverse direction is presented. The procedure, proposed by Priestley [Priestley, et al., 2007], is implemented in Matlab and is then applied to different possible regular bridge configurations, in which are varied the number of spans, the shape of the valley under the bridge, abutment restraints, seismic intensity and the deck transverse stiffness, in order to:",
	      _react2.default.createElement(
	        "ul",
	        null,
	        _react2.default.createElement(
	          "li",
	          null,
	          "Evaluate the displacement shape depending on abutment restraints;"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "Define a range of the design drift of each bridge configuration;"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "Implement a parametric analysis to evaluate the influence of design parameters on the DDBD of multi-span continuous bridges."
	        )
	      ),
	      " ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "h3",
	        null,
	        "Flavio di Maggio, 2017/2018"
	      ),
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Main supervisor: Prof. Domenico Raffaele"
	      ),
	      _react2.default.createElement("img", { src: _6.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Implementation and validation of a finite-difference algorithm for tall RC bridge piers"
	      ),
	      "The purpose of this study is to investigate the influence of gravity loads and large displacements theory, generally known as second order P-delta effects, on the stability of high bridge piers. P-Delta is a non-linear effect that occurs in every structure where elements are subjected to axial load. Seismic evaluation of slender concrete columns has clearly shown reduction in the shear capacity for a given performance limit state and incorporating P-delta effects in the analysis. The main objective for incorporating gravity loads coupled with large displacements theory in the seismic design/analysis of bridge columns is to capture the effect that second order P-delta amplifications have on the inelastic response of these columns. In recent decades, the instability effects caused by gravity loads in the design of bridge columns have been the subject of several studies. ",
	      _react2.default.createElement("br", null),
	      "The large deformation analysis takes full account of the effect due to the deformed shape of the structure and its member. When structures become slenderer and less resistant to deformation, consideration of second order effects is essential for tall members. ",
	      _react2.default.createElement("br", null),
	      "The case study of the following thesis is a hollow reinforced concrete bridge pier, analysed under gravity load and wind load. The bridge pier is splitted and the problem is solved using a finite difference method. Pushover analysis is a nonlinear static analysis procedure which can consider P \u2013 delta effects. According to the Eurocode, if the change in bending moments and displacements is more than 10%, P \u2013 delta effects should be considered in design. By a parametric analysis any numerical input variable of the model can be changed. The first step in analysing model behaviour is to select one or more input variables as parameters and assign to each parameter a list of possible values. Through this analysis it is possible to see how they affects the output results and which combinations of input give a higher percentage than 10%. ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "h3",
	        null,
	        "Vincenzo Venisti, 2017/2018"
	      ),
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Main supervisor: Prof. Domenico Raffaele"
	      ),
	      _react2.default.createElement("img", { src: _8.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Implementation of capacity models for the seismic assessment of RC bridge piers"
	      ),
	      "La valutazione del livello di sicurezza delle costruzioni esistenti, molte delle quali sono datate e progettate secondo una normativa che non prevede un\u2019adeguata filosofia antisismica, \xE8 uno dei temi di maggiore interesse della moderna Ingegneria. Considerando il grande numero di strutture e la ristrettezza delle risorse economiche a disposizione, \xE8 necessaria una razionalizzazione e semplificazione dei metodi di analisi di vulnerabilit\xE0 sismica. ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      "Restringendo il campo alle strutture da ponte si pu\xF2 dire che esse hanno una notevole rilevanza poich\xE9 in molti casi risultano essere nodi cruciali delle rete di trasporti; caratteristica che fa si che il loro livello prestazionale debba essere garantito anche nei momenti immediatamente successivi ad un sisma. ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      "Focalizzando l\u2019attenzione sulle pi\xF9 comuni strutture da ponte, ossia i ponti e viadotti ad impalcato in semplice appoggio, in questo lavoro di tesi viene realizzato un modello in Excel che permette di valutare la loro curva di capacit\xE0. In particolare, per un\u2019analisi di vulnerabilit\xE0 \xE8 possibile assumere che la curva di capacit\xE0 della struttura sia approssimabile con la curva di capacit\xE0 della pila critica. ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      "Il comportamento di una pila pu\xF2 essere, in generale, influenzato da vari meccanismi quali la flessione, il taglio, gli effetti del secondo ordine, lo sfilamento delle barre longitudinali o la loro instabilizzazione. Il comportamento flessionale \xE8 noto se si conosce il diagramma Momento-Curvatura della sezione di base e la lunghezza di cerniera plastica. ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      "Mentre per la valutazione del taglio, dell\u2019instabilit\xE0 delle barre e degli effetti del secondo ordine vengono utilizzate delle formulazioni approssimate, per il comportamento flessionale ci si serve di un metodo semplificato che si basa su pochi parametri di input, con il quale \xE8 possibile ricavare il diagramma Momento-Curvatura e la lunghezza di cerniera plastica.",
	      _react2.default.createElement(
	        "h3",
	        null,
	        "Leonardo Fondi, 2016/2017"
	      ),
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Main supervisor: Prof. Stefano Pampanin"
	      ),
	      _react2.default.createElement("img", { src: _10.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Parametric seismic vulnerability analysis for existing RC buildings"
	      ),
	      "Questo studio si pone come obiettivo studiare il rapporto esistente tra lacapacit\xE0 sismoresistente e la probabilit\xE0 di superamento dello stato limite ultimo considerando l'aleatoreit\xE0 della resistenza dei materiali costitutivi e della domanda, in funzione dell'epoca di costruzione. A partire da questi risultati \xE8 possibile valutare quale sia il componente che ha maggiore infl\x1Duenza sul comportamento globale della struttura, in modo da poter concentrare, in fase di valutazione della vulnerabilit\xE0 sismica, gli sforzi di de\x1Cfinizione del modello sulle caratteristiche pi\xF9 importanti, potendo ragionevolmente evitare di approfondire le altre in un'ottica di riduzione dei costi. ",
	      _react2.default.createElement("br", null),
	      "Per farlo, considerato un edi\x1Ccio modello le cui caratteristiche sono state valutate attraverso un progetto simulato in funzione delle di\x1Bfferenti norme che si sono succedute in Italia, \xE8 stata valutata la pushover e, variando parametricamente le caratteristiche dei materiali,il relativo fascio. A partire da questo, considerando la variabilit\xE0 della domanda, \xE8 possibile ottenere le curve di fragilit\xE0 e quindi studiarne la sensibilit\xE0 costruendo dei fusi. In questo modo sar\xE0 possibile valutare contemporaneamente la distanza tra le curve di fragilit\xE0 causata dalla variabilit\xE0 delle caratteristiche dei materiali e quella causata dai dettagli costruttivi e valutarne di conseguenza le estensioni.",
	      _react2.default.createElement(
	        "h3",
	        null,
	        "Pierpaolo Dispoto, 2015/2016"
	      ),
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Main supervisor: Prof. Domenico Raffaele"
	      ),
	      _react2.default.createElement("img", { src: _12.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Effects of shear on the ductility of RC bridge piers"
	      ),
	      "In Italia, fino ad ora, si sono verificati pochi eventi sismici che, per intensit\xE0 e frequenza, hanno provocato gravi danni ad infrastrutture di importanza strategica come ponti. Nonostante ci\xF2, nel corso degli anni, la comunit\xE0 scientifica ha mostrato una crescente sensibilizzazione al problema della vulnerabilit\xE0 sismica, concretizzatasi con l\u2019emanazione delle Normative tecniche di ultima generazione. L\u2019input di questa maggiore sensibilizzazione \xE8 stata l\u2019esperienza di altri Paesi, come per esempio quella della California, la quale ha fatto capire che l\u2019eventuale ritardo riguardo l\u2019adozione di una normativa idonea, potrebbe avere conseguenze devastanti: quindi un atteggiamento di prevenzione \xE8 senza alcun dubbio la strada da seguire. Infatti, in California, solo dopo 12 anni dal terremoto di San Fernando (nel 1971) che caus\xF2 collassi di ponti costruiti da poco, venne pubblicato dalla Federal Highway Administration (FHWA) un primo documento intitolato \u201CRetrofitting guidelines for Highway Bridges\u201D (ATC, 1983). In seguito, nel 1989, nonostante fosse gi\xE0 stato attuato anche un vasto, ma inadeguato, programma di rinforzo preventivo, il successivo terremoto di Loma Prieta evidenzi\xF2 una errata filosofia progettuale. Pertanto, \xE8 diventata prioritaria la volont\xE0 di trovare un metodo scientifico idoneo a valutare la vulnerabilit\xE0 dei ponti gi\xE0 esistenti, ossia la propensione di una struttura a subire un danno di un determinato livello a fronte di un evento sismico di una data intensit\xE0. Ovviamente, quanto appena detto, non pu\xF2 prescindere da una valutazione che permetta di ottimizzare il metodo stesso con riferimento a costi e benefici, ora pi\xF9 che mai necessaria se si considera il momento storico che il nostro paese sta attraversando, caratterizzato da una grave crisi economica. Inoltre, il metodo in questione deve essere tale da permettere una valutazione veloce (basata su semplici rilevazioni) e oggettiva di tutte le strutture che verranno esaminate, in modo da capire su quali di queste sar\xE0 prioritario intervenire. Quindi, considerato che le nuove opere in Italia vengono ormai progettate secondo adeguate Normative antisismiche, il presente lavoro di tesi \xE8 rivolto alla valutazione della vulnerabilit\xE0 sismica dei ponti costruiti prima dell\u2019entrata in vigore delle Normative di ultima generazione. I criteri su cui si fonda tale valutazione sono criteri oggettivi perch\xE9 costituiti da algoritmi che nascono dall\u2019elaborazione di un elevatissimo numero di dati ottenuti con un modello meccanico.",
	      _react2.default.createElement(
	        "h3",
	        null,
	        "Vito Dalessio, 2014/2015"
	      ),
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Main supervisor: Prof. Domenico Raffaele"
	      ),
	      _react2.default.createElement("img", { src: _14.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Plastic hinge length calibration for RC bridge piers with solid and hollow circular cross-sections"
	      ),
	      "The bridge substructure modeling has a great importance because column and support devices are the site of the main phenomena that can compromise the bridge functionality and integrity. In the columns, particularly, a great part of the structure dissipative capacities is concentrated and, therefore, a correct analytical modeling is important to evaluate the structure's inelastic potentialities. The modelling with plasticity concentrated is the more useful (by a computational point of view) among the many, because it combines the materials no-linearity in a few points of the structure. In this case, along the element axis is possible to identify two parts: one elastic and the other inelastic; the inelastic part is of adequate length, called \"plastic hinge length\" but of which we do not know the entity, in which at the SLU all the sections reach the same plastic curvature. ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement("br", null),
	      "In literature there are various relation to calculate this length, such as those of Priestley and Park, relations that depend on columns height, longitudinal bars diameter and steel resistance to yielding. In this thesis i wanted to calculate the influence of other parameters on the evaluation of this dimension, such as: the geometry and the section dimensions, the normal stress adimensionalized, the mechanical percentage of the longitudinal reinforcing steel, the geometric percentage of the reinforcing steel transversal and the concrete's resistance to compression. I performed static non-linear analysis (pushover) with diffused plasticity for 3 types of sections (circular, circular hollow, and rectangular), assigning different values to the parameters chosen as representative. I have extract, by these analisys, the last displacement in the head and, putting it equal to that extract by the analysis with concentrated plasticity, i have indirectly calculate the length of plastic hinge. ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement("br", null),
	      "As a result, thanks to a data analysis i have calculate the influence of the various parameters on the determination of this length. Finally, through the Curve Fitting operation, i have extract reports that, assigned the representative parameters, provide the value of the plastic hinge length expressed as a percentage of the column height.",
	      _react2.default.createElement(
	        "h3",
	        null,
	        "Caterina Masucci, 2013/2014"
	      ),
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Main supervisor: Prof. Domenico Raffaele"
	      ),
	      _react2.default.createElement("img", { src: _16.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Seismic vulnerability analysis of simply supported RC bridges with wall piers"
	      ),
	      "Nel presente lavoro di tesi ,si propone una procedura di valutazione della vulnerabilit\xE0 delle pile a setto in cemento armato, di ponti a travata. La tipologia di ponte e la forma della sezione analizzata, rendono ampiamente spendibile il lavoro nella fase di assessement di viadotti esistenti. ",
	      _react2.default.createElement("br", null),
	      "L\u2019importanza strategica che le strutture da ponte ricoprono all\u2019interno della rete stradale , \xE8 in netto contrasto con le modalit\xE0 di progettazione che ,nelle strutture pi\xF9 datate, mancano di una corretta filosofia sismica. Le strutture in c.a. progettate in assenza di adeguata normativa sismica di ultima generazione, sono generalmente caratterizzate da una bassa duttilit\xE0 disponibile, conseguente all'assenza di un\u2019appropriata gerarchia delle resistenze in grado di favorire la formazione di meccanismi di collasso di tipo globale, alla carenza nella cura dei dettagli costruttivi ed al basso livello di confinamento del calcestruzzo nelle zone critiche. ",
	      _react2.default.createElement("br", null),
	      "Obiettivo della procedura, \xE8 quello di rilevare i rapporti meccanici e parametri geometrici  caratteristici della pila in esame, che inseriti nelle  formulazioni in forma chiusa ottenute,portino alla individuazione dei principali punti attraverso cui schematizzare il diagramma momento-curvatura della pila in esame.              La modalit\xE0 con cui i risultati vengono esposti,espressioni analitiche in forma chiusa, si dimostra particolarmente efficace per l\u2019analisi di vulnerabilit\xE0 di strutture esistenti,poich\xE8 i parametri utilizzati sono oggettivi e di immediata determinazione per ciascuna struttura (rapporto meccanico di armatura longitudinale, rapporto meccanico di armatura trasversale,ecc). ",
	      _react2.default.createElement("br", null),
	      "Il lavoro \xE8 cominciato col fissare le caratteristiche meccaniche della sezione in c.a.(resistenza a compressione del calcestruzzo, resistenza allo snervamento dell\u2019acciaio) e col definire un range di variazione per i quattro parametri adimensionali utilizzati:sforzo normale, percentuale di armatura longitudinale,percentuale di armatura trasversale, rapporto di allungamento della sezione. ",
	      _react2.default.createElement("br", null),
	      "I differenti parametri adimensionali sono stati combinati tra loro,in modo da ottenere un\u2019ampia casistica di sezioni  ipotizzate. Si \xE8 poi sottoposta ciascuna sezione ad una analisi momento-curvatura attraverso un software di calcolo. ",
	      _react2.default.createElement("br", null),
	      "Il software attraverso cui le analisi sono state effettuate, ha permesso  di ottenere, per ciascuna sezione, una curva momento-curvatura. Le analisi sono state fatte in condizioni di pressoflessione, tenendo conto di una azione verticale ,non trascurabile, rappresentativa dell\u2019azione esplicata dal peso strutturale dell\u2019impalcato del ponte. L\u2019insieme delle curve ottenute ha portato alla creazione di un cospicuo database,su cui si sono svolte le successive operazioni. ",
	      _react2.default.createElement("br", null),
	      "Ottenuto il database,si \xE8 progettata una funzione in ambiente Matlab ,che ha permesso l\u2019individuazione dei  punti notevoli delle curve,al fine di cogliere le principali variazioni che la sezione subisce come  conseguenza all\u2019incremento del momento flettente. Ogni punto notevole \xE8 dato da una coppia di dati momento-curvatura.",
	      _react2.default.createElement(
	        "h3",
	        null,
	        "Giulia Marselia, 2013/2014"
	      ),
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Main supervisor: Prof. Domenico Raffaele"
	      ),
	      _react2.default.createElement("img", { src: _18.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Seismic vulnerability analysis of simply supported RC bridges with piers with hollow circular cross-section"
	      ),
	      "Le normative strutturali che si sono succeduta a partire dalla O.P.C.M. 3274/2003 in avanti possono essere definite \u201Cdi ultima generazione\u201D ma il cambiamento verso una progettazione antisismica \xE8 stato s\xEC drastico nei contenuti, ma dilatato nei tempi. A causa di una lunga serie di proroghe, infatti, le normative di ultima generazione sono cogenti solo dal 1 luglio 2009. ",
	      _react2.default.createElement("br", null),
	      "Inoltre, le normative di ultima generazione hanno una sola origine: la nuova zonazione sismica italiana della O.P.C.M. 3274/2003. La nuova zonazione ha adeguato la pericolosit\xE0 sismica di normativa dei comuni italiani all\u2019effettiva pericolosit\xE0 sismica. ",
	      _react2.default.createElement("br", null),
	      "Inoltre, i criteri di progettazione seguiti in passato si basavano sulla resistenza. L\u2019edificio doveva resistere alle azioni rimanendo in campo elastico; il criterio prende il nome di FBD, Force Based Design, ovvero una progettazione basata sulle forze, sulla resistenza per l\u2019appunto. Ma mantenere l\u2019edificio in campo elastico sotto l\u2019azione di un sisma comporta il dover sovradimensionare la struttura e non sfruttare le eventuali maggiori risorse della stessa. Le risorse cui si fa riferimento sono quelle in campo plastico, pi\xF9 precisamente le escursioni in campo plastico che definiscono la cosiddetta duttilit\xE0 strutturale. Il passo successivo \xE8 stato sfruttare al meglio la duttilit\xE0 e dissipare l\u2019energia con appositi accorgimenti. Questo ha portato alla definizione del criterio della gerarchia delle resistenze ed alle soluzioni a dissipazione concentrata. Inoltre, uno degli argomenti pi\xF9 importanti dell\u2019Ingegneria delle Strutture \xE8 l\u2019analisi di vulnerabilit\xE0 che consente di valutare il livello di sicurezza delle costruzioni esistenti. In Italia, come altrove, sono presenti strutture e infrastrutture datate che non sono progettate secondo gli attuali codici normativi e, pertanto, \xE8 importante conoscere lo stato di consistenza delle strutture per predisporre piani di intervento e di manutenzione. ",
	      _react2.default.createElement("br", null),
	      "Questo lavoro di tesi si sofferma maggiormente sulle strutture da ponte, la cui capacit\xE0 di dissipare energia \xE8 affidata completamente alle pile e per analizzarle si usa uno schema statico a mensola. Un\u2019analisi di vulnerabilit\xE0 di un ponte semplicemente appoggiato pu\xF2 essere sintetizzata dall\u2019analisi della sua pila critica. L\u2019analisi di quest\u2019ultima pu\xF2 essere a sua volta ricondotta all\u2019analisi della sua sezione d\u2019incastro. Pertanto, l\u2019obiettivo di questo lavoro \xE8 quello di fornire delle relazioni adimensionali per stimare i valori dei punti notevoli di una curva momento-curvatura riferita alla sezione di una pila circolare cava. A tal proposito sono state condotte una serie di analisi momento- curvatura facendo variare di volta in volta quattro parametri fondamentali entro un preciso range. Per concludere si \xE8 confrontato il comportamento di una sezione circolare cava con quello di una sezione piena, lo scopo del confronto \xE8 quello di vedere come all\u2019aumentare della cavit\xE0 all\u2019interno della sezione il comportamento della stessa cambia e ci si allontana sempre di pi\xF9 dalla sezione circolare piena."
	    )
	  );
	};
	exports.default = Master;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tutoring-en-jsx-d186f7a7375313f8a0df.js